import WorkersPage from "@/views/Workers.vue";
import WorkersList from "@/components/workers/List.vue";
import WorkersInfo from "@/components/workers/Info.vue";
import WorkersCreate from "@/components/workers/Create.vue";

const workers = [
  {
    path: "/workers",
    component: WorkersPage,
    children: [
      {
        path: "",
        name: 'WorkersList',
        component: WorkersList,
      },
      {
        path: ":id",
        name: "WorkersInfo",
        component: WorkersInfo,
        props: true,
      },
      {
        path: "create",
        name: "WorkersCreate",
        component: WorkersCreate,
      },
    ]
  },
];

export default workers;